import { render, staticRenderFns } from "./RulePanel.vue?vue&type=template&id=71a6f100&scoped=true&"
import script from "./RulePanel.vue?vue&type=script&lang=js&"
export * from "./RulePanel.vue?vue&type=script&lang=js&"
import style0 from "./RulePanel.vue?vue&type=style&index=0&id=71a6f100&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6f100",
  null
  
)

export default component.exports